import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useTaskCategory, TaskCategory } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => {
  return (
    <GenericDetailPage<TaskCategory>
      useData={useTaskCategory}
      config={{
        ...moduleConfig,
        getDetailSections,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
